import type { SystemConfig } from '@/types/setting'

/** 是否展示注册入口（登录页链接、首页 CTA 等） */
export function canShowRegisterEntry(config: SystemConfig | null | undefined): boolean {
  if (!config) return false
  return Boolean(config.is_email || config.is_phone)
}
